<template>
  <div>
    <b-card>
      <div
        class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
      >
        <h3 class="mt-1 d-flex align-items-center">
          <feather-icon
            icon="ArrowUpCircleIcon"
            class="mr-50"
            style="width: 18px; height: 18px"
          />
          <span>Withdraw</span>
        </h3>
        <div class="d-flex">
          <b-button
            class="gradient-btn mt-1 d-flex align-items-center"
            :to="{ name: 'account-withdraw' }"
            v-if="$route.name == 'wallet-withdraw'"
          >
            <feather-icon
              icon="ArrowUpCircleIcon"
              class="mr-50"
              style="width: 18px; height: 18px"
            />
            <span> Withdraw </span></b-button
          >
        </div>
      </div>
      <b-form
        @submit.prevent="filter"
        class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
      >
        <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
          <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
          <v-select
            :options="types"
            v-model="type"
            label="label"
            :reduce="(option) => option.value"
            :searchable="false"
            placeholder="Display on the page"
            class="w-100"
          ></v-select>
        </div>

        <div class="col-sm-6 col-12 d-flex align-items-center flex-wrap p-50">
          <template v-if="type == 'payable'">
            <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
              <select-box
                v-model="payable_type"
                class="w-100"
                searchable
                :lists="['user', 'partner', 'competition', 'plan']"
              />
            </div>
            <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
              <select-box
                v-model="payable_id"
                label="text"
                class="w-100"
                select="id"
                searchable
                :url="payable_type"
              />
            </div>
          </template>

          <b-form-input
            v-else
            placeholder="search"
            v-model.trim="search"
            :disabled="!type"
          />
        </div>
        <div class="col-sm-3 col-12 p-50">
          <b-button
            class="w-100"
            type="submit"
            :disabled="!search && !(!search && payable_type && payable_id)"
          >
            <span class="text-muted h5"> Filtering</span>
          </b-button>
        </div>
      </b-form>
      <data-table :fields="fields" :items="transactions" :loading="loading">
        <template #uuid="{ data }">
          <div
            class="d-flex align-items-center"
            v-b-tooltip.hover="data.item.uuid"
          >
            <div class="text-truncate" style="max-width: 250px">
              {{ data.item.uuid }}
            </div>
            <div>
              <feather-icon
                icon="CopyIcon"
                width="40px"
                class="ml-sm-75 cursor-pointer"
                @click="doCopy(data.item.uuid)"
              />
            </div>
          </div>
        </template>
        <template #type="{ data }">
          <b-badge
            :variant="data.item.type == 'withdraw' ? 'danger' : 'success'"
            style="white-space: nowrap"
          >
            {{ data.item.type }}
          </b-badge>
        </template>
        <template #gateway="{ data }">
          <span
            v-if="hasOwnNestedProperty(data.item, 'meta.data.type')"
            v-b-tooltip.hover.v-primary="data.item.meta.data.id"
            style="white-space: nowrap"
          >
            {{ data.item.meta.data.type }}
          </span>
          <span v-else>-</span>
        </template>
        <template #message="{ data }">
          <span
            v-if="hasOwnNestedProperty(data.item, 'meta.message')"
            style="white-space: nowrap"
          >
            {{ data.item.meta.message }}
          </span>
          <span
            v-else-if="hasOwnNestedProperty(data.item, 'meta.data.message')"
          >
            {{ data.item.meta.data.message }}
          </span>
          <span v-else>-</span>
        </template>
        <template #amount="{ data }">
          <span class="mb-0 text-green" style="white-space: nowrap">
            {{
              data.item.amount_float
                ? `${
                    0 > data.item.amount_float
                      ? Math.abs(data.item.amount_float).toFixed(2)
                      : data.item.amount_float
                  } $`
                : "-"
            }}
          </span>
        </template>
        <template #payable="{ data }">
          <span style="white-space: nowrap">
            {{
              data.item.payable
                ? data.item.payable.name
                  ? data.item.payable.name
                  : data.item.payable.first_name +
                    " " +
                    data.item.payable.last_name
                : "-"
            }}
          </span>
        </template>

        <template #created_at="{ data }">
          <span class="" style="white-space: nowrap">
            {{ toLocal(data.item.created_at) }}
          </span>
        </template>
      </data-table>

      <div
        class="w-100 d-flex flex-wrap align-items-center justify-content-between"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="lg"
          pills
          class="my-2 d-flex justify-content-center"
        >
        </b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import qs from "qs";
import VSelect from "vue-select";
import SelectBox from "@core/components/select-box/SelectBox.vue";
export default {
  components: {
    VBTooltip,
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    VSelect,
    SelectBox,
  },
  data() {
    return {
      currentPage: 1,
      visibleCreateDeposit: false,
      loading: false,
      pagination: {},
      fields: [],
      transactions: [],
      types: [
        { label: "Id", value: "uuid" },
        { label: "Amount", value: "amount" },
        { label: "Payable", value: "payable" },
      ],
      type: "",
      search: "",
      payable_type: "",
      payable_id: "",
    };
  },

  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  watch: {
    async type(val) {
      this.search = await "";
      if (Object.keys(this.$route.query).length) {
        this.$router.push({
          ...this.calRoute("withdraw"),
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          ...this.calRoute("withdraw"),
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.fields =
          this.$route.name == "wallet-deposit"
            ? [
                { key: "uuid", label: "id" },
                { key: "gateway", label: "gateway" },
                { key: "message", label: "message" },
                { key: "amount", label: "amount" },
                { key: "created_at", label: "created at" },
              ]
            : [
                { key: "uuid", label: "id" },
                { key: "payable", label: "wallet" },
                { key: "gateway", label: "gateway" },
                { key: "message", label: "message" },
                { key: "amount", label: "amount" },
                { key: "created_at", label: "created at" },
              ];

        this.getTransfers();
      },
      immediate: true,
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          this.$router.push({
            name: "wallet-withdraw",
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "wallet-withdraw",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        if (this.type == "payable") {
          filter = {
            payable: {
              type: this.payable_type,
              id: this.payable_id,
            },
          };
        } else {
          filter[this.type] = this.search;
        }

        if (this.type == "uuid") {
          if (this.validatorUuid(this.search)) {
            this.$router
              .push({
                ...this.calRoute("withdraw"),
                query: {
                  ...this.$route.query,
                  filter,
                },
              })
              .catch((err) => {});
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "The id is invalid!",
                icon: "CoffeeIcon",
                variant: "warning",
              },
            });
          }
        } else {
          this.$router.push({
            ...this.calRoute("withdraw"),
            query: {
              ...this.$route.query,
              filter,
            },
          });
        }
      } else if (Object.keys(this.$route.query).length) {
        this.$router.push({
          ...this.calRoute("withdraw"),
        });
      }
    },
    doCopy(id) {
      this.$copyText(id).then(
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Text copied",
              icon: "BellIcon",
            },
          });
        },
        (e) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Can not copy!",
              icon: "BellIcon",
            },
          });
        }
      );
    },
    calRoute(path) {
      return this.$route.name.includes("competition")
        ? {
            name: `competition-wallet-${path}`,
            params: { name: this.$route.params.id },
          }
        : this.$route.name.includes("user")
        ? {
            name: `user-wallet-${path}`,
            params: { name: this.$route.params.id },
          }
        : this.$route.name.includes("partner")
        ? {
            name: `partner-wallet-${path}`,
            params: { name: this.$route.params.id },
          }
        : this.$route.name.includes("plan")
        ? {
            name: `plan-wallet-${path}`,
            params: { name: this.$route.params.id },
          }
        : {
            name: `wallet-${path}`,
          };
    },
    calApiRoute(path) {
      return this.$route.name.includes("competition")
        ? `/panel/competitions/${this.$route.params.id}/${path}`
        : this.$route.name.includes("user")
        ? `/panel/users/${this.$route.params.id}/${path}`
        : this.$route.name.includes("partner")
        ? `/panel/partners/${this.$route.params.id}/${path}`
        : this.$route.name.includes("plan")
        ? `/panel/plans/${this.$route.params.id}/${path}`
        : `/panel/profile/user/${path}`;
    },
    async getTransfers() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          filter: {
            type: "withdraw",
            ...this.$route.query.filter,
          },
        };
        const { data } = await this.$http.get(
          this.calApiRoute("transactions"),
          {
            params,
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          }
        );
        this.transactions = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
